import { useLocation } from 'react-router-dom';
import { useCallback, useState } from 'react';
import usePagination from './usePagination';

const permanentIgnoreList = ['pageSize', 'sortField', 'sortOrder', 'cartId'];

const useClearAllFilters = (ignoreList: string[] = []) => {
    const { navigateToPage } = usePagination();
    const { search } = useLocation();
    const [updatedSearch, setUpdatedSearch] = useState<URLSearchParams>(
        new URLSearchParams(search)
    );

    return useCallback(() => {
        const clearedSearch = new URLSearchParams(updatedSearch);
        Array.from(updatedSearch.entries())
            .filter(
                ([name]) =>
                    ![...ignoreList, ...permanentIgnoreList].includes(name)
            )
            .forEach(([name]) => {
                clearedSearch.delete(name);
            });

        clearedSearch.delete('minPrice');
        clearedSearch.delete('maxPrice');
        clearedSearch.delete('onSale');
        clearedSearch.delete('bestAvailability');
        navigateToPage(1, clearedSearch.toString());

        setUpdatedSearch(clearedSearch);
    }, [ignoreList, navigateToPage, updatedSearch]);
};

export default useClearAllFilters;
